import { useContext } from "react";
import { MedicationsDrawerContext } from "./MedicationsDrawerProvider";

export const useMedicationsDrawer = () => useContext(MedicationsDrawerContext);
